import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router";

export const Content = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const Header = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.75),
}));

export const TrophyIcon = styled(EmojiEventsOutlinedIcon)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.gold.dark,
}));

export const Title = styled(Typography)({
  fontWeight: 600,
});

export const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const UpgradeLink = styled(Link)(({ theme }) => ({
  display: "block",
  textAlign: "center",
  padding: theme.spacing(0.75, 1.5),
  borderRadius: 999,
  backgroundColor: theme.palette.gold.main,
  color: theme.palette.gold.contrastText,
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.2,
  textDecoration: "none",
  transition: theme.transitions.create("background-color", { duration: 150 }),

  "&:hover": {
    backgroundColor: theme.palette.gold.light,
  },
}));
